/**
 * Big Win Class
 *
 *
 */

(function () {
  class BigWin extends PIXI.Container {
    constructor() {
      super();

      // Big win levels
      this.BIG_WIN = 1;
      this.SUPER_WIN = 2;
      this.MEGA_WIN = 3;
      this.EPIC_WIN = 4;
      this.AWESOME_WIN = 5;

      this._bigWinThreshold = 20;
      this._superWinThreshold = 100;
      this._megaWinThreshold = 250;
      this._epicWinThreshold = 500;
      this._awesomeWinThreshold = 1000;

      this._totalDuration = 8000;
      this._winType = this.BIG_WIN;

      this.bigWinLevel = [
        {
          bigWinType: 'BIGWIN',
          countTime: 5,
          threshold: this._bigWinThreshold,
          state: 'INITBIGWIN',
        },
        {
          bigWinType: 'SUPERWIN',
          countTime: 7,
          threshold: this._superWinThreshold,
          state: 'INITBIGWIN',
        },
        {
          bigWinType: 'MEGAWIN',
          countTime: 9,
          threshold: this._megaWinThreshold,
          state: 'INITBIGWIN',
        },
        {
          bigWinType: 'EPICWIN',
          countTime: 11,
          threshold: this._epicWinThreshold,
          state: 'INITBIGWIN',
        },
        {
          bigWinType: 'AWESOMEWIN',
          countTime: 13,
          threshold: this._awesomeWinThreshold,
          state: 'INITBIGWIN',
        },
      ];

      this.bigWinState = 'IDLE';

      this.textTween = undefined;
      this.isActive = false;
      this.skipWin = false;
      this.allowSkipWin = false;

      // index into bigWinLevel array
      this.currentLevel = 0;

      this._thresholdMultiplier = 0;

      this.scaleIncrease = 0;

      this.winAmount = 0;

      this.callback = undefined;

      messageBus.subscribe('spinner:WinningLinesEvent', this.doPayWins.bind(this));
      messageBus.subscribe('stake:stakeChanged', this.onStakeChanged.bind(this));

      const self = this;

      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState('IDLE', function () {});

      // these states are for non big wins
      this.stateMachine.addState('LOSSWIN', function () {
        self.updateLossWinState();
      });
      this.stateMachine.addState('LOWWIN', function () {
        self.updateLowWinState();
      });
      this.stateMachine.addState('MIDWIN', function () {
        self.updateMidWinState();
      });
      this.stateMachine.addState('SHOWWINENDING', function () {
        self.updateShowWinText();
      });

      this.stateMachine.addState('INITBIGWIN', function () {
        self.updateInitBigWin();
      });
      this.stateMachine.addState('BIGWIN', function () {
        self.updateBigWin();
      });
      this.stateMachine.addState('SUPERWIN', function () {
        self.updateSuperWin();
      });
      this.stateMachine.addState('MEGAWIN', function () {
        self.updateMegaWin();
      });
      this.stateMachine.addState('EPICWIN', function () {
        self.updateEpicWin();
      });
      this.stateMachine.addState('AWESOMEWIN', function () {
        self.updateAwesomeWin();
      });

      this.stateMachine.addState('BOUNCEANDGROW', function () {
        self.updateBounceAndGrow();
      });
      this.stateMachine.addState('ENDSTAGE', function () {
        self.updateEndStage();
      });
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    onStakeChanged(stake) {
      this._bigWinCurrentStake = stake;
    }

    getWinType(amount) {
      var stake = gameController.globalHelperGetStake();

      if (amount >= stake * this._awesomeWinThreshold) {
        return this.AWESOME_WIN;
      } else if (amount >= stake * this._epicWinThreshold) {
        return this.EPIC_WIN;
      } else if (amount >= stake * this._megaWinThreshold) {
        return this.MEGA_WIN;
      } else if (amount >= stake * this._superWinThreshold) {
        return this.SUPER_WIN;
      } else {
        return this.BIG_WIN;
      }
    }

    getBigWinThreshold() {
      return this._bigWinThreshold;
    }

    getSuperWinThreshold() {
      return this._superWinThreshold;
    }

    getMegaWinThreshold() {
      return this._megaWinThreshold;
    }

    getEpicWinThreshold() {
      return this._epicWinThreshold;
    }

    getAwesomeWinThreshold() {
      return this._awesomeWinThreshold;
    }

    willTriggerBigWin(amount) {
      const stake = gameController.globalHelperGetStake();
      const threshold = stake * this.getBigWinThreshold();
      return amount >= threshold;
    }

    panelPulse(panel) {
      this._panelPulse = gsap.to(panel.scale, {
        duration: 0.15,
        x: 1.2,
        y: 1.2,
        repeat: 3,
        yoyo: true,
      });
    }

    init() {
      this._dimScreen = resourceManager.get('bigWinDimObject');
      this._dimScreen.show(false);

      this._bigWinContainer = resourceManager.getContainer('bigWinContainer');
      this._bigWinContainer.visible = false;

      // Value Text Backing
      this._winAwardTextBacking = resourceManager.get('bigWin:awardTextBacking');
      this._winAwardTextBacking.visible = false;

      // Value Text Backing
      this._winAwardTextBackingFish = resourceManager.get('bigWin:awardTextBackingFish');
      this._winAwardTextBackingFish.visible = false;

      this._congratsText = resourceManager.get('bigWin:bigwinCongrats');
      this._congratsText.visible = false;
      // NOTE: This uses a meter - you can't override the font size of the meter
      this._winAwardTextBack = resourceManager.get('bigWin:awardText');
      this._winAwardTextBack.visible = false;

      this._awardTextFinalPos = resourceManager.get('bigWin:awardTextFinalPos');
      this._awardTextStartPos = resourceManager.get('bigWin:awardTextStartPos');

      this._awardTextBackOffset = 10;

      this._bigWinTextContainer = resourceManager.get('bigWin:bigWinTextContainer');
      this._bigWinTextContainer.visible = false;

      this._superWinTextContainer = resourceManager.get('bigWin:superWinTextContainer');
      this._superWinTextContainer.visible = false;

      this._megaWinTextContainer = resourceManager.get('bigWin:megaWinTextContainer');
      this._megaWinTextContainer.visible = false;

      this._epicWinTextContainer = resourceManager.get('bigWin:epicWinTextContainer');
      this._epicWinTextContainer.visible = false;

      this._awesomeWinTextContainer = resourceManager.get('bigWin:awesomeWinTextContainer');
      this._awesomeWinTextContainer.visible = false;

      this._bigwinCongrats = resourceManager.get('bigWin:bigwinCongrats');
      this._bigwinCongrats.visible = false;

      this._bigwinYouWon = resourceManager.get('bigWin:bigwinYouWon');
      this._bigwinYouWon.visible = false;

      this.burst = resourceManager.get('bigWin:Burst');
      this.burst.visible = false;

      this._emitterDiamondBig = particleManager.createEmitter(
        'bigwin_emitter_4',
        'bigWin:particlesContainer',
        0,
        0,
        false
      );
      this._emitterDiamondBig.particleEmitter.emit = false;
      this._emitterDiamondBig.visible = false;

      this._emitterDiamondSmall = particleManager.createEmitter(
        'bigwin_emitter_2',
        'bigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._emitterDiamondSmall.particleEmitter.emit = false;
      this._emitterDiamondSmall.visible = false;

      this._skipBigWinBox = resourceManager.get('bigWin:skipBigWinBox');

      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.visible = false;
      this._skipBigWinBox.interactive = false;

      this._cappedWinPopup = resourceManager.get('maxWinPopup');
      this._cappedWinPopup.visible = false;
      this._cappedWinPopupButton = resourceManager.get('maxWinPopup:continueButton');
      this._cappedWinPopupButton.interactive = false;

      this.gameContainer = resourceManager.getContainer('gameContainer');
      this.btnContainer = resourceManager.getContainer('gameButtonContainer');
    }

    isBigWinActive() {
      return this.isActive;
    }

    showCappedWinPopup(callback) {
      this._cappedWinPopup.visible = true;
      this._cappedWinPopup.alpha = 0;
      this.isActive = true;

      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          self._cappedWinPopup.alpha = progress;
        },
        function () {
          self._cappedWinPopup.alpha = 1;

          self._cappedWinPopupButton.interactive = true;
          self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = function () {
            self._cappedWinPopup.visible = false;
            self._cappedWinPopupButton.interactive = false;
            self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = function () {};
            callback();
          };
        }
      );

      // Set up this popup for auto-closing during replays
      game.autoClickForReplayRewatchTimer(() => {
        self._cappedWinPopup.visible = false;
        self._cappedWinPopupButton.interactive = false;
        self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = function () {};
        callback();
      });
    }

    start(winAmount, callback, capped) {
      if (capped) {
        const self = this;
        this.showCappedWinPopup(function () {
          self.startBigWin(winAmount, callback);
        });
      } else {
        this.startBigWin(winAmount, callback);
      }

      //resourceManager.getContainer('DemoContainer').visible = false;
    }

    startBigWin(winAmount, callback) {
      this._dimScreen.show(true);
      this._dimScreen.alpha = 0;

      gsap.to(this._dimScreen, {
        duration: 0.3,
        alpha: 0.6,
      });

      gameData.topLayerMeters.visible = true;

      this.callback = callback;
      this.winAmount = winAmount;

      this.isActive = true;
      this.skipWin = false;
      this.allowSkipWin = false;

      // find win levels
      this.currentLevel = 0;
      this.scaleIncrease = 0;

      this._winAwardTextBack.position.setY(this._awardTextStartPos.position.getY());
      this._winAwardTextBack.alpha = 1.0;

      this.gameContainer.visible = false;
      this.btnContainer.visible = false;

      this._bigWinContainer.visible = true;
      this.burst.visible = true;

      this.pulseTween = gsap.fromTo(
        this.burst.scale,
        {
          x: 1,
          y: 1,
        },
        {
          paused: true,
          delay: 0,
          duration: 0.5,
          x: 1.2,
          y: 1.2,
          yoyo: true,
          repeat: -1,
        }
      );
      this.pulseTween.time(0).restart(true);

      this.burst.rotation = 0;

      this.rotateTween = gsap.to(this.burst, {
        duration: 3,
        rotation: Math.PI * 2,
        repeat: -1,
        ease: 'none',
      });
      this.rotateTween.time(0).restart(true);

      this.visible = true;

      this.winAmount = this.winAmount;
      const stake = gameController.globalHelperGetStake();

      this.currentState = undefined;

      // do we do the big free spins anim in free spins mode? find highest level
      for (var i = this.bigWinLevel.length - 1; i >= 0; i--) {
        if (this.winAmount >= this.bigWinLevel[i].threshold * stake) {
          this.targetLevel = this.bigWinLevel[i].bigWinId;

          this.currentState = this.bigWinLevel[i].state;
          break;
        }
      }

      // wait for click - anywhere on screen
      this._skipBigWinBox.visible = true;
      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.interactive = true;
      this._skipBigWinBox.mousedown = this._skipBigWinBox.touchstart = this.skip.bind(this);

      this.stateMachine.switchState(this.currentState);

      //soundManager.play('bigWinLoop');

      Reflex.registerEventHandler('orientationChange', this.orientationChange.bind(this));
    }

    doPayWins(winTask) {
      // this.winAmount = winTask.data.totalLineWinnings;
    }

    canSkip() {
      return this.isActive && !this.skipWin && this.allowSkipWin;
    }

    updateLossWinState() {
      // just show the text - outro then slides text to middle and alpha out
      // skip win - fade immediately
      // don't allow skip win for a certain amount of time - button needs to check if we can allow skip win
      if (this.phase.once()) {
        this.countUpSound = undefined;

        this.allowSkipWin = true;

        this._winAwardTextBacking.visible = true;
        this._winAwardTextBackingFish.visible = true;
        this._congratsText.visible = true;

        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.set(this.winAmount);
        this._winAwardTextBack.alpha = 1;
        this._winAwardTextBack.visible = true;

        this._finalScaleX = 1.0;
        this._finalScaleY = 1.0;
      }

      if (this.phase.timed(700)) {
        if (this.skipWin) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('SHOWWINENDING');
      }
    }

    updateLowWinState() {
      if (this.phase.once()) {
        this.allowSkipWin = true;

        this._winAwardTextBacking.visible = true;
        this._winAwardTextBackingFish.visible = true;
        this._congratsText.visible = true;

        this._winAwardTextBack.set(this.winAmount);
        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        this._finalScaleX = 1.2;
        this._finalScaleY = 1.2;
        this.countUpSound = soundManager.play('winCountUp');
      }

      // are we skipping the win
      if (this.skipWin) {
        this.stateMachine.switchState('SHOWWINENDING');
      }

      // scale up and fade in
      if (this.phase.timed(500)) {
        this._winAwardTextBack.scale.x = 1.0 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1.0 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.alpha = this.phase.Progress;
      }

      // scale back down
      if (this.phase.timed(142)) {
        this._winAwardTextBack.scale.x = 1.5 - 0.3 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1.5 - 0.3 * this.phase.Progress;
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('SHOWWINENDING');
      }

      // end phase
      if (this.phase.exit()) {
        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.alpha = 1;
        soundManager.stop('winCountUp');
        soundManager.play('bigWinCountUpEnd');
      }
    }

    updateMidWinState() {
      if (this.phase.once()) {
        this.allowSkipWin = true;

        this._winAwardTextBacking.visible = true;
        this._winAwardTextBackingFish.visible = true;
        this._congratsText.visible = true;

        this._winAwardTextBack.set(0);
        this._winAwardTextBack.scale.x = 5;
        this._winAwardTextBack.scale.y = 5;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        const stake = gameController.globalHelperGetStake();

        const maxTime = 3000;
        const minTime = 1000;
        const deltaTime = maxTime - minTime;
        const maxValue = 20 * stake;
        const minValue = 3 * stake;

        const normalisedWin = this.winAmount - minValue;
        const normalisedMax = maxValue - minValue;
        const ratio = normalisedWin / normalisedMax;

        function clamp(val, min, max) {
          return val > max ? max : val < min ? min : val;
        }

        const countUpTime = clamp(ratio * deltaTime + minTime, minTime, maxTime);

        this.countUpSound = soundManager.play('winCountUp');

        this._winAwardTextBack.countUp(this.winAmount, countUpTime);
      }

      // skip win and force countup to final value
      if (this.skipWin) {
        this.stateMachine.switchState('SHOWWINENDING');
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // scale up and fade in
      if (this.phase.timed(500)) {
        this._winAwardTextBack.scale.x = 0.5 + 0.7 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 0.5 + 0.7 * this.phase.Progress;
        this._winAwardTextBack.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this._winAwardTextBack.scale.x = 1.2;
        this._winAwardTextBack.scale.y = 1.2;
        this._winAwardTextBack.alpha = 1;
      }

      // bounce down
      if (this.phase.timed(142)) {
        this._winAwardTextBack.scale.x = 1.2 - 0.2 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1.2 - 0.2 * this.phase.Progress;
      }

      if (this.phase.once()) {
        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
      }

      // bounce back to 1.2x
      if (this.phase.timed(200)) {
        this._winAwardTextBack.scale.x = 1 + this.phase.Progress * 0.2;
        this._winAwardTextBack.scale.y = 1 + this.phase.Progress * 0.2;
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('SHOWWINENDING');
      }

      if (this.phase.exit()) {
        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.alpha = 1;
      }
    }

    updateShowWinText() {
      const startPos = this._awardTextStartPos.position.getY();
      const endPos = this._awardTextFinalPos.position.getY();

      this._winAwardTextBack.alpha = 1;
      this._winAwardTextBack.visible = false;

      // we can't skip the final tidy up of the value
      if (this.phase.once()) {
        soundManager.stop('winCountUp');
        soundManager.play('bigWinCountUpEnd');
      }

      if (this.phase.timed(750)) {
        // let the player see their win - do nothing
      }

      // now move the text down and fade off
      if (this.phase.timed(300)) {
        const newYPos = startPos + (endPos - startPos) * this.phase.Progress;

        this._winAwardTextBack.position.setY(newYPos);
        this._winAwardTextBack.alpha = 1.0 - this.phase.Progress;
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('IDLE');
      }

      if (this.phase.exit()) {
        this._winAwardTextBack.position.setY(endPos);
        this._winAwardTextBack.alpha = 1;
        this._winAwardTextBack.visible = false;

        if (this.callback) {
          this.isActive = false;
          this.callback();
          this.callback = undefined;
        }
      }
    }

    // Big win code - drop text into position - this can't be skipped
    updateInitBigWin() {
      const startScale = 1.5;

      this._winType = this.getWinType(this.winAmount);

      if (this.phase.enter()) {
        musicManager.playBigWin();

        this._emitterDiamondBig.particleEmitter.emit = true;
        this._emitterDiamondBig.visible = true;

        this._emitterDiamondSmall.particleEmitter.emit = true;
        this._emitterDiamondSmall.visible = true;

        this._currentPanel = this._bigWinTextContainer;
        this._currentPanel.alpha = 0;
        this._currentPanel.visible = true;
        this._currentPanel.scale.x = startScale;
        this._currentPanel.scale.y = startScale;

        this._winAwardTextBacking.visible = true;
        this._winAwardTextBackingFish.visible = true;
        //this._congratsText.visible = true;

        this._winAwardTextBack.scale.x = 0.5;
        this._winAwardTextBack.scale.y = 0.5;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        const threshold = gameController.globalHelperGetStake() * this.getBigWinThreshold();
        const amountToCountUp = Math.min(threshold, this.winAmount);

        this._winAwardTextBack.position.setY(this._awardTextStartPos.position.getY());

        this._winAwardTextBack.set(0);

        this.countUpSound = soundManager.play('winCountUp');

        this._winAwardTextBack.countUp(amountToCountUp, 1500);
      }

      if (this.phase.timed(500)) {
        this._winAwardTextBack.scale.x = 0.5 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 0.5 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
        this._winAwardTextBack.alpha = 1;
      }

      if (this.phase.timed(1000)) {
        const startPos = this._awardTextStartPos.position.getY();
        const endPos = this._awardTextFinalPos.position.getY();
        const distance = (endPos - startPos) * this.phase.Progress;

        this._winAwardTextBack.position.setY(startPos + distance);
      }

      if (this.phase.once()) {
        this._winAwardTextBack.position.setY(this._awardTextFinalPos.position.getY());

        this.stateMachine.switchState('BIGWIN');
      }
    }

    updateBigWin() {
      const startScale = 8;
      const endScale = 1;
      const totalScaleTravel = startScale - endScale;

      // do the count up - this is zero to big win threshold - then super is mega - big
      // dim the screen
      if (this.phase.enter()) {
        this.allowSkipWin = true;

        const threshold = gameController.globalHelperGetStake() * this.getSuperWinThreshold();
        const previousThreshold = gameController.globalHelperGetStake() * this.getBigWinThreshold();
        const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;
        this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
      }
      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }
      // old stage three
      if (this.phase.timed(300)) {
        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);

        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }
      if (this.phase.once()) {
        this.panelPulse(this._currentPanel);
      }
      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }
      if (this.phase.once()) {
        this._panelPulse.pause();
        this.stateMachine.switchState('BOUNCEANDGROW');
      }
      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        // which state next
        if (this.winAmount >= gameController.globalHelperGetStake() * this.getSuperWinThreshold()) {
          this.currentState = 'SUPERWIN';
        } else {
          this._thresholdMultiplier = this.getBigWinThreshold();
          this.currentState = 'ENDSTAGE';
        }
      }
    }

    updateSuperWin() {
      const startScale = 8;
      const endScale = 1;

      const totalScaleTravel = startScale - endScale;

      if (this.phase.enter()) {
        this._previousPanel = this._bigWinTextContainer;
        this._currentPanel = this._superWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;
          this._currentPanel.scale.x = startScale;
          this._currentPanel.scale.y = startScale;

          const threshold = gameController.globalHelperGetStake() * this.getMegaWinThreshold();
          const previousThreshold = gameController.globalHelperGetStake() * this.getSuperWinThreshold();

          const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;
          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        this._previousPanel.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(200)) {
        if (this._previousPanel !== undefined) {
          this._previousPanel.alpha = 0;
        }

        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);
        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      if (this.phase.once()) {
        if (this._previousPanel !== undefined) {
          this._previousPanel.scale.x = 1;
          this._previousPanel.scale.y = 1;
          this._previousPanel.alpha = 1;
          this._previousPanel.visible = false;
        }

        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        this.panelPulse(this._currentPanel);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this._panelPulse.pause();
        this.stateMachine.switchState('BOUNCEANDGROW');
      }

      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        // which state next
        if (this.winAmount >= gameController.globalHelperGetStake() * this.getMegaWinThreshold()) {
          this.currentState = 'MEGAWIN';
        } else {
          this._thresholdMultiplier = this.getSuperWinThreshold();
          this.currentState = 'ENDSTAGE';
        }
      }
    }

    updateMegaWin() {
      const startScale = 8;
      const endScale = 1;

      const totalScaleTravel = startScale - endScale;

      if (this.phase.enter()) {
        this._previousPanel = this._superWinTextContainer;
        this._currentPanel = this._megaWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;
          this._currentPanel.scale.x = startScale;
          this._currentPanel.scale.y = startScale;

          const threshold = gameController.globalHelperGetStake() * this.getEpicWinThreshold();
          const previousThreshold = gameController.globalHelperGetStake() * this.getMegaWinThreshold();

          const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;

          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        this._previousPanel.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(200)) {
        if (this._previousPanel !== undefined) {
          this._previousPanel.alpha = 0;
        }

        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);
        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      if (this.phase.once()) {
        if (this._previousPanel !== undefined) {
          this._previousPanel.scale.x = 1;
          this._previousPanel.scale.y = 1;
          this._previousPanel.alpha = 1;
          this._previousPanel.visible = false;
        }

        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        this.panelPulse(this._currentPanel);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this._panelPulse.pause();
        this.stateMachine.switchState('BOUNCEANDGROW');
      }

      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        // which state next
        if (this.winAmount >= gameController.globalHelperGetStake() * this.getEpicWinThreshold()) {
          this.currentState = 'EPICWIN';
        } else {
          this._thresholdMultiplier = this.getMegaWinThreshold();
          this.currentState = 'ENDSTAGE';
        }
      }
    }

    updateEpicWin() {
      const startScale = 8;
      const endScale = 1;

      const totalScaleTravel = startScale - endScale;

      if (this.phase.enter()) {
        this._previousPanel = this._megaWinTextContainer;
        this._currentPanel = this._epicWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;
          this._currentPanel.scale.x = startScale;
          this._currentPanel.scale.y = startScale;

          const threshold = gameController.globalHelperGetStake() * this.getAwesomeWinThreshold();
          const previousThreshold = gameController.globalHelperGetStake() * this.getEpicWinThreshold();

          const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;
          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        this._previousPanel.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(200)) {
        if (this._previousPanel !== undefined) {
          this._previousPanel.alpha = 0;
        }

        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);
        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      if (this.phase.once()) {
        if (this._previousPanel !== undefined) {
          this._previousPanel.scale.x = 1;
          this._previousPanel.scale.y = 1;
          this._previousPanel.alpha = 1;
          this._previousPanel.visible = false;
        }

        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        this.panelPulse(this._currentPanel);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this._panelPulse.pause();
        this.stateMachine.switchState('BOUNCEANDGROW');
      }

      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        // which state next
        if (this.winAmount >= gameController.globalHelperGetStake() * this.getAwesomeWinThreshold()) {
          this.currentState = 'AWESOMEWIN';
        } else {
          this._thresholdMultiplier = this.getEpicWinThreshold();
          this.currentState = 'ENDSTAGE';
        }
      }
    }

    updateAwesomeWin() {
      const startScale = 7;
      const endScale = 1;
      const totalScaleTravel = startScale - endScale;

      if (this.phase.enter()) {
        this._previousPanel = this._epicWinTextContainer;
        this._currentPanel = this._awesomeWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;
          this._currentPanel.scale.x = startScale;
          this._currentPanel.scale.y = startScale;

          // do the countup
          const threshold = gameController.globalHelperGetStake() * this.getAwesomeWinThreshold();
          const amountToCountUp = this.winAmount - threshold;

          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState('ENDSTAGE');
        this._previousPanel.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      if (this.phase.timed(200)) {
        if (this._previousPanel !== undefined) {
          this._previousPanel.alpha = 0;
        }

        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);
        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      if (this.phase.once()) {
        this.panelPulse(this._currentPanel);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('ENDSTAGE');
      }

      if (this.phase.exit()) {
        this._thresholdMultiplier = this.getAwesomeWinThreshold();

        if (this._previousPanel !== undefined) {
          this._previousPanel.scale.x = 1;
          this._previousPanel.scale.y = 1;
          this._previousPanel.alpha = 1;
          this._previousPanel.visible = false;
        }
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;
      }
    }

    // Bounce and grow code
    updateBounceAndGrow() {
      if (this.phase.enter()) {
      }

      if (this.phase.once()) {
        if (this.currentState === 'ENDSTAGE') {
          this.stateMachine.switchState(this.currentState);
          return;
        }
      }

      if (this.phase.once()) {
        this._currentPanel.Props.orgScaleX = this._currentPanel.scale.x;
        this._currentPanel.Props.orgScaleY = this._currentPanel.scale.y;
      }

      if (this.skipWin) {
        this.stateMachine.switchState(this.currentState);
      }

      // bounce panel
      if (this.phase.timed(150)) {
        let newScale = (Math.sin(Math.PI * this.phase.Progress) * 10) / 100;
        this._currentPanel.scale.x = this._currentPanel.Props.orgScaleX + newScale;
        this._currentPanel.scale.y = this._currentPanel.Props.orgScaleY + newScale;
      }

      if (this.phase.once()) {
        this._currentPanel.Props.orgScaleX = this._currentPanel.scale.x;
        this._currentPanel.Props.orgScaleY = this._currentPanel.scale.y;
      }

      // move to the next stage of the big win sequence
      if (this.phase.once()) {
        this.stateMachine.switchState(this.currentState);
      }

      if (this.phase.exit()) {
      }
    }

    updateEndStage() {
      if (this.phase.once()) {
        this.stateMachine.switchState('IDLE');
      }

      if (this.phase.exit()) {
        this.showEndScreen();
      }
    }

    showEndScreen() {
      soundManager.stop('winCountUp');
      soundManager.stop('bigWinLoop');

      soundManager.play('bigWinCountUpEnd');
      soundManager.play('bigWinEnd');

      musicManager.restartBaseMusic();

      this._bigwinCongrats.visible = true;
      this._bigwinYouWon.visible = true;
      this._bigwinYouWon.alpha = 0;

      this._currentPanel.alpha = 1;
      this._currentPanel.visible = true;
      this._currentPanel.scale.x = 1;
      this._currentPanel.scale.y = 1;

      this._congratsText.alpha = 0;
      this._congratsText.visible = true;

      const self = this;

      timerManager.addTimer(
        250,
        function (progress) {
          self._currentPanel.alpha = 1 - progress;
          self._congratsText.alpha = progress;
        },
        function () {
          self._currentPanel.alpha = 0;
          self._congratsText.alpha = 1;
        }
      );

      timerManager.addTimer(
        2250,
        function (progress) {
          musicManager.fadeBigWin(1 - progress);
        },
        function () {
          self.outro();
        }
      );
    }

    outro() {
      gameData.topLayerMeters.visible = false;

      let self = this;
      timerManager.addTimer(
        1000,
        function (progress) {
          self.alpha = 1 - progress;
          self._dimScreen.setAlpha(0.7 * (1 - progress));
        },
        function () {
          self._currentPanel.visible = false;
          self._currentPanel.alpha = 1;
          self._currentPanel.scale.x = 1;
          self._currentPanel.scale.y = 1;

          self.alpha = 1;
          self.visible = false;

          self.gameContainer.visible = true;
          self.btnContainer.visible = true;

          self._bigwinCongrats.visible = false;
          self._bigwinYouWon.visible = false;

          self._emitterDiamondSmall.particleEmitter.emit = false;
          self._emitterDiamondSmall.visible = false;

          self._emitterDiamondBig.particleEmitter.emit = false;
          self._emitterDiamondBig.visible = false;

          self.pulseTween.time(0).restart(false);

          self.rotateTween.time(0).restart(false);

          self._winAwardTextBacking.visible = false;
          self._winAwardTextBackingFish.visible = false;
          self._congratsText.visible = false;

          self._winAwardTextBack.position.setY(self._awardTextStartPos.position.getY());
          self._winAwardTextBack.alpha = 1;
          self._winAwardTextBack.visible = false;

          self.burst.visible = false;

          self._dimScreen.show(false);

          self._rotate = false;

          Reflex.deregisterEventHandler('orientationChange', self.orientationChange.bind(self));

          self.isActive = false;

          self._skipBigWinBox.alpha = 0;
          self._skipBigWinBox.visible = false;
          self._skipBigWinBox.interactive = false;

          soundManager.stop('winCountUp');

          if (self.callback) self.callback();
        }
      );
    }

    orientationChange() {
      this._awardTextFinalPos = resourceManager.get('bigWin:awardTextFinalPos');
      this._winAwardTextBack.position.y = this._awardTextFinalPos.position.getY();
    }

    skip() {
      if (this.canSkip()) {
        this.skipWin = true;
      }
    }
  }

  var bigWinCreator = function (json) {
    return new BigWin();
  };

  var bigWinInitialiser = function (json, bigWin) {};

  var bigWinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('BigWin', bigWinCreator, bigWinInitialiser, bigWinFilesRequired);
})();
